import { FC, useState } from "react";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiButtonTertiary,
} from "../..";
import { useSiteCore } from "../../../hooks/useSiteCore";
import { CancelFieldModal } from "../../../pages/createProgramTemplate/components/cancelFieldModal/CancelFieldModal";
import { BulkInsertFooterWrapper } from "./BulkInsertFooter.style";

interface BulkInsertFooterProps {
  pageId: string;
  isFiledUpdated?: boolean;
  confirmButtonText?: string;
  onConfirmClick?: () => void;
  handleNavigateBack?: () => void;
  showBackButton?: boolean;
  handleBackButtonClick?: () => void;
  disableConfirmButton?: boolean;
  cancelMessage?: string;
  cancelTitle?: string;
  showCloseButtonOnly?: boolean;
}

export const BulkInsertFooter: FC<BulkInsertFooterProps> = ({
  pageId,
  isFiledUpdated,
  confirmButtonText,
  onConfirmClick,
  handleNavigateBack,
  showBackButton = false,
  handleBackButtonClick,
  disableConfirmButton = false,
  cancelMessage,
  cancelTitle,
  showCloseButtonOnly,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { commonLabels } = useSiteCore();

  const handleModalClose = () => {
    setShowCancelModal(false);
  };

  const onCancelButtonClick = () => {
    if (isFiledUpdated) {
      setShowCancelModal(true);
    } else {
      handleNavigateBack?.();
    }
  };

  const okButtonHandler = () => {
    handleModalClose();
    handleNavigateBack?.();
  };

  return (
    <BulkInsertFooterWrapper>
      <MuiBox>
        {showBackButton && (
          <MuiButtonTertiary
            data-testid={`${pageId}-back`}
            onClick={handleBackButtonClick}
          >
            <ArrowBackIosIcon />
            {commonLabels.back}
          </MuiButtonTertiary>
        )}
      </MuiBox>
      <MuiBox className="button-container">
        {showCloseButtonOnly ? (
          <MuiButtonSecondary
            onClick={handleNavigateBack}
            id={`${pageId}-close`}
          >
            {commonLabels.close}
          </MuiButtonSecondary>
        ) : (
          <>
            <MuiButtonSecondary
              id={`${pageId}-cancel`}
              onClick={onCancelButtonClick}
            >
              {commonLabels.cancel}
            </MuiButtonSecondary>
            <MuiButtonPrimary
              onClick={onConfirmClick}
              id={`${pageId}-confirm`}
              disabled={disableConfirmButton}
            >
              {confirmButtonText}
            </MuiButtonPrimary>
          </>
        )}
      </MuiBox>
      {showCancelModal && (
        <CancelFieldModal
          title={cancelTitle ?? commonLabels.cancelChanges}
          showModal={showCancelModal}
          handleModalClose={handleModalClose}
          handlePrimaryButtonClick={okButtonHandler}
          cancelMessage={cancelMessage ?? commonLabels.cancelButtonAlertText}
        />
      )}
    </BulkInsertFooterWrapper>
  );
};
